import { ItemDocumentFinderThemeModeConfig } from './types';

const light: ItemDocumentFinderThemeModeConfig = {
  itemDocumentFinder: {},
};

export default light;
